import angular from 'angular';

import { MULTIPLE_ASSIGNEE_OPTIONS, ALERT_MESSAGES } from './constants';
import modalViewUrl from './modal-view.html';

export default class EditTaskCtrl {
  modalViewUrl = modalViewUrl;

  constructor(
    Authentication,
    ConfirmService,
    PersonaCollection,
    Restangular,
    ShiftUtils,
    Tasks,
    TaskCollection,
    TaskService,
    Upload,
    Utils,
    focus,
    task,
    toTimeFilter,
    $filter,
    $q,
    $scope,
    $timeout,
    $uibModalInstance,
    $window
  ) {
    'ngInject';

    Object.assign(this, {
      Authentication,
      ConfirmService,
      PersonaCollection,
      Restangular,
      ShiftUtils,
      Tasks,
      TaskCollection,
      TaskService,
      Upload,
      Utils,
      focus,
      task,
      toTimeFilter,
      $filter,
      $q,
      $scope,
      $timeout,
      $uibModalInstance,
      $window,
    });

    this.init();
  }

  init() {
    this.focus('focus');

    this.viewmode = Boolean(this.task.id);
    this.uploader = angular.copy(this.Upload.uploader);
    this.uploader.url = `${this.Restangular.configuration.baseUrl}/upload/image?skipTranscoding=true`;
    this.personas = this.PersonaCollection.canSeeOtherLocations
      ? this.PersonaCollection.personas
      : this.PersonaCollection.visibleUsers;
    this.users = this.PersonaCollection.visibleUsers;
    this.editTask = this.Restangular.copy(this.task);
    this.hasAccessToUser = this.PersonaCollection.hasAccessToUser;

    this._initDates();
    this.multipleAssigneeOptions = MULTIPLE_ASSIGNEE_OPTIONS;
    this._setHoursOptions();

    // Upload
    this.uploader.onSuccessItem = (fileItem, response) => {
      response.fileName = fileItem.file.name;
      this.editTask.attachments.push(response);
      this.$scope.form.$setDirty();
    };

    this.uploader.onErrorItem = (item, response, status) => {
      if (status in ALERT_MESSAGES) {
        this.$window.alert(ALERT_MESSAGES[status]);
      }
    };
  }

  _failure(error) {
    this.error = this.Utils.getErrorMessages(error);
  }

  _initDates() {
    this.dueTimeObject = new Date();
    this.notificationDateFormat = 'EEEE • MMMM dd';
    if (this.editTask.hasTime) {
      this.dueTime = this.toTimeFilter(this.editTask.dueDate);
      this.initialDueTime = this.dueTime || null;
      this.notificationDateFormat += this.Authentication.user.settings.usTimeFormat
        ? ' • h:mm a'
        : ' • H:mm';
    }
  }

  async submit(taskParam, addAnother) {
    const task = this.Restangular.copy(taskParam);
    task.hasTime = !!this.dueTime;
    if (this.dueTime) {
      this.updateDueDate(task.dueDate, this.dueTimeObject);
    }

    this.error = false;
    let promise;

    if (!task.personas || !task.personas.length) {
      task.personas = [{ id: this.Authentication.user.id }];
    }

    if (task.id) {
      // Update
      try {
        promise = await task.withHttpConfig({ ignoreGlobalErrorHandler: true }).put();
        this.$uibModalInstance.close();
        return promise;
      } catch (e) {
        this._failure(e);
      }
    } else {
      // Insert
      promise = await this.Tasks.withHttpConfig({ ignoreGlobalErrorHandler: true }).post(task, {
        'user-fields': 'id',
      });
      try {
        if (addAnother) {
          this.task = {
            attachments: [],
          };
          this.$scope.form.$setPristine();
          this.$scope.form.$setUntouched();
        } else {
          this.$uibModalInstance.close();
        }
      } catch (e) {
        this._failure(e);
      }
    }

    return promise;
  }

  cancelEdit() {
    this.dueTime = this.initialDueTime;
    if (this.task.id) {
      this.viewmode = true;
      return;
    }

    this.$scope.$dismiss();
  }

  async deleteTask() {
    await this.ConfirmService.ask('Are you sure you want to cancel this task?');
    const canceledTask = this.task.cancelTask();
    this.$uibModalInstance.close();
    return canceledTask;
  }

  removeUpload(index) {
    this.editTask.attachments.splice(index, 1);
    this.$scope.form.$setDirty();
  }

  clickUploadButton() {
    this.$timeout(() => {
      document.getElementById('task-file-upload').click();
    });
  }

  isGroupTask(_task) {
    return (
      _task.personas.length &&
      (_task.personas.some((p) => p.type !== 'user') || _task.personas.length > 1)
    );
  }

  updateDueDate(targetDate, date) {
    targetDate.setHours(date.getHours(), date.getMinutes(), 0, 0);
    this.dueTime = this.toTimeFilter(targetDate);
  }

  updateDueTime(date) {
    if (!this.dueTimeObject) {
      this.dueTimeObject = new Date();
    }

    this.dueTimeObject.setHours(date.getHours(), date.getMinutes(), 0, 0);
    this.dueTime = this.toTimeFilter(this.dueTimeObject);
    this.$scope.form.$setDirty();
  }

  clearDueDate() {
    this.dueTime = null;
    this.editTask.dueDate = null;
    this.$scope.form.$setDirty();
  }

  _setHoursOptions() {
    const { visibleHoursStart, visibleHoursEnd } = this.Authentication.user.orgSettings;
    const { visibleStart, visibleEnd } = this.Utils.getVisibleHoursBoundaries(
      visibleHoursStart,
      visibleHoursEnd
    );

    const hourOptions = this.Utils.getHourOptions(
      visibleStart,
      false,
      visibleStart.getHours(),
      visibleStart.getMinutes()
    ).map(timeFormatLabels.bind(this));
    this.hourOptions = hourOptions.filter(
      (option) => option.value >= visibleStart && option.value <= visibleEnd
    );

    function timeFormatLabels(item) {
      item.label = this.toTimeFilter(item.label);
      return item;
    }
  }

  modalNotification() {
    if (this.editTask.completed) {
      return this.TaskService.getCompletedMessage(this.editTask, this.notificationDateFormat);
    }
  }

  modalClass() {
    if (this.editTask.completed) {
      return 'notification-green';
    }
  }

  async goToHistoryMode() {
    this.historyMode = true;
    this.history = await this.TaskCollection.getLogs(this.editTask.id);
  }

  goBack() {
    this.historyMode = false;
  }
}
